import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import * as actions from "../../../actions/InstallationActions";
import { Link } from "react-router-dom";

export function SortAndFilterButtons({sort, filter, listType, handleFilterToggle}) {

    const dispatch = useDispatch();
    const [showFilterForm, setShowFilterForm] = useState(false);

    const handleFilterToggleClick = () => {
        setShowFilterForm(!showFilterForm);
        if (showFilterForm) {
            dispatch(actions.FilterNone(listType, sort));
        }
        handleFilterToggle();
    };

    const handleSortChange = (e) => {
        const selectedValue = e.target.value;
        switch (selectedValue) {
            case `SortNew${listType.toUpperCase()}`:
                dispatch(actions.SortNew(listType));
                break;
            case `SortOld${listType.toUpperCase()}`:
                dispatch(actions.SortOld(listType));
                break;
            case `SortAtoZ${listType.toUpperCase()}`:
                dispatch(actions.SortAtoZ(listType));
                break;
            default:
                break;
        }
    };

    return (

        <div className="container InstallerListHeader">

            <Link to="/installation" className="btn btn-secondary back-button" >
                <span className="back-button-arrow"></span> Back
            </Link>

            <h1 className ="InstallerList-title">{listType.charAt(0).toUpperCase() + listType.slice(1)} Installation Jobs</h1>

            <div className="btn-col d-grid btn-group-filter">
                
                    <button className="btn btn-secondary filter-button" onClick={handleFilterToggleClick}>
                        {filter === 'none' ? 'Add Filter' : showFilterForm ? 'Remove Filter' : 'Add Filter'}
                    </button>
                    <select className="btn btn-secondary filter-button" onChange={handleSortChange}>
                        <option value={`SortNew${listType.toUpperCase()}`}>Sorting by: New</option>
                        <option value={`SortOld${listType.toUpperCase()}`}>Sorting by: Old</option>
                        <option value={`SortAtoZ${listType.toUpperCase()}`}>Sorting by: A to Z</option>
                    </select>
              
            </div>
            
        </div>
    );
}